import defaultSettings from '@/settings'
import i18n from '@/lang'

const title = defaultSettings.title

export default function getPageTitle (key) {
  const hasKey = i18n.te(`route.${key}`)
  const pageTitle = i18n.t(`route.${title}`)
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`)
    return `${pageName} - ${pageTitle}`
  }
  return `${pageTitle}`
}



// WEBPACK FOOTER //
// ./src/utils/get-page-title.js